/**
 * Talents Initiative (مبادرة مواهب) - Mock Data
 * Realistic Arabic data for all dashboard sections
 * TODO: Replace with React Query hooks when backend API is ready
 */

import {
  HeroBannerData,
  CategoryBreakdown,
  Specialization,
  AnnualForumData,
  Teacher,
  Student,
  PaginatedData,
  TalentsFilters,
  ProjectDetailData,
  OutputGalleryData,
  StudentDetailData,
} from './types';
import { CalendarEvent } from '../../components/ActivityCalendar/types';

// ============================================================
// Section 1: Hero Banner
// ============================================================
export const MOCK_HERO_BANNER: HeroBannerData = {
  title: 'مبادرة مواهب',
  subtitle: 'مبادرة سنوية مقامة برعاية مكتب سمو ولي العهد',
  organizationName: 'مبادرة مواهب',
};

// ============================================================
// Section 2: Statistics
// ============================================================
export const MOCK_STATISTICS: CategoryBreakdown[] = [
  {
    title: 'المشاركين وفق الفئات العمرية',
    total: 34,
    showTotal: true,
    segments: [
      { label: 'المرحلة الثانوية', value: 12, color: '#3a5aa3' },
      { label: 'المرحلة المتوسطة', value: 14, color: '#414042' },
      { label: 'المرحلة التأسيسية', value: 8, color: '#a6813f' },
    ],
  },
  {
    title: 'المشاركين وفق فئات المستويات',
    total: 34,
    showTotal: false,
    segments: [
      { label: 'الناشئة', value: 14, color: '#a6813f' },
      { label: 'الواعدة', value: 9, color: '#414042' },
      { label: 'المتميزة', value: 6, color: '#3a5aa3' },
      { label: 'القابلة للتمثيل الخارجي', value: 5, color: '#a9211f' },
    ],
  },
];

// ============================================================
// Section 3: Specializations
// ============================================================
export const MOCK_SPECIALIZATIONS: Specialization[] = [
  {
    id: 1,
    title: 'التصوير والرسم والنحت',
    progress: 76,
    kpiCount: 3,
    activityCount: 3,
    participantCount: 14,
    color: '#414042',
  },
  {
    id: 2,
    title: 'العزف والغناء',
    progress: 85,
    kpiCount: 2,
    activityCount: 2,
    participantCount: 10,
    color: '#a6813f',
  },
  {
    id: 3,
    title: 'التمثيل المسرحي والإخراج',
    progress: 81,
    kpiCount: 2,
    activityCount: 2,
    participantCount: 6,
    color: '#3a5aa3',
  },
  {
    id: 4,
    title: 'رقص الباليه',
    progress: 68,
    kpiCount: 2,
    activityCount: 1,
    participantCount: 4,
    color: '#a9211f',
  },
];

// ============================================================
// Section 4: Annual Forum
// ============================================================
export const MOCK_ANNUAL_FORUM: AnnualForumData = {
  title: 'الملتقى السنوي',
  year: 2026,
  location: 'الفجيرة',
  startDate: '1 ديسمبر',
  endDate: '15 ديسمبر 2026',
  status: 'approved',
};

// ============================================================
// Section 5: Teachers
// ============================================================
const SCHOOLS = [
  'مدرسة الفجيرة النموذجية',
  'مدرسة الإمارات الخاصة',
  'مدرسة الشارقة الدولية',
  'المدرسة الأمريكية للإبداع',
  'مدرسة دبي الوطنية',
  'أكاديمية الفنون الدولية',
  'أكاديمية التربية الفنية',
];

const SPECIALIZATIONS_LIST = [
  'التصوير والرسم والنحت',
  'العزف والغناء',
  'التمثيل المسرحي والإخراج',
  'رقص الباليه',
];

const TEACHING_SPECS = [
  'التربية الفنية',
  'الموسيقى والإيقاع',
  'الفنون المسرحية',
  'الرقص التعبيري',
  'التصوير الفوتوغرافي',
  'النحت والتشكيل',
  'الفنون البصرية',
];

const MOCK_TEACHERS_ALL: Teacher[] = [
  { id: 1, name: 'أحمد محمد العلي', teachingSpecialization: 'التربية الفنية', specialization: 'التصوير والرسم والنحت', school: 'مدرسة الفجيرة النموذجية', email: 'ahmed.ali@production.ae', phone: '05 55 555 5555', isVerified: true, isActive: true, hasCertificate: true, projectNames: [] },
  { id: 2, name: 'فاطمة سعيد الحسن', teachingSpecialization: 'الموسيقى والإيقاع', specialization: 'العزف والغناء', school: 'مدرسة الإمارات الخاصة', email: 'fatima.h@production.ae', phone: '05 55 555 5555', isVerified: true, isActive: true, hasCertificate: true, projectNames: [] },
  { id: 3, name: 'خالد عبدالله النعيمي', teachingSpecialization: 'الفنون المسرحية', specialization: 'التمثيل المسرحي والإخراج', school: 'مدرسة الشارقة الدولية', email: 'khalid.n@production.ae', phone: '05 55 555 5555', isVerified: true, isActive: true, hasCertificate: false, projectNames: [] },
  { id: 4, name: 'مريم يوسف الشامسي', teachingSpecialization: 'الرقص التعبيري', specialization: 'رقص الباليه', school: 'المدرسة الأمريكية للإبداع', email: 'mariam.s@production.ae', phone: '05 55 555 5555', isVerified: true, isActive: true, hasCertificate: true, projectNames: [] },
  { id: 5, name: 'عمر حسن المزروعي', teachingSpecialization: 'التصوير الفوتوغرافي', specialization: 'التصوير والرسم والنحت', school: 'مدرسة دبي الوطنية', email: 'omar.m@production.ae', phone: '05 55 555 5555', isVerified: true, isActive: true, hasCertificate: true, projectNames: [] },
  { id: 6, name: 'نورة أحمد الكتبي', teachingSpecialization: 'النحت والتشكيل', specialization: 'التصوير والرسم والنحت', school: 'أكاديمية الفنون الدولية', email: 'noura.k@production.ae', phone: '05 55 555 5555', isVerified: false, isActive: true, hasCertificate: true, projectNames: [] },
  { id: 7, name: 'سعيد محمد الظاهري', teachingSpecialization: 'الفنون البصرية', specialization: 'التصوير والرسم والنحت', school: 'أكاديمية التربية الفنية', email: 'saeed.d@production.ae', phone: '05 55 555 5555', isVerified: true, isActive: true, hasCertificate: true, projectNames: [] },
  { id: 8, name: 'حصة خالد المهيري', teachingSpecialization: 'الموسيقى والإيقاع', specialization: 'العزف والغناء', school: 'مدرسة الفجيرة النموذجية', email: 'hessa.m@production.ae', phone: '05 55 555 5555', isVerified: true, isActive: true, hasCertificate: false, projectNames: [] },
  { id: 9, name: 'راشد علي الحمادي', teachingSpecialization: 'التربية الفنية', specialization: 'التصوير والرسم والنحت', school: 'مدرسة الإمارات الخاصة', email: 'rashed.h@production.ae', phone: '05 55 555 5555', isVerified: true, isActive: true, hasCertificate: true, projectNames: [] },
  { id: 10, name: 'عائشة سالم الشرقي', teachingSpecialization: 'الفنون المسرحية', specialization: 'التمثيل المسرحي والإخراج', school: 'مدرسة الشارقة الدولية', email: 'aisha.s@production.ae', phone: '05 55 555 5555', isVerified: true, isActive: true, hasCertificate: true, projectNames: [] },
  { id: 11, name: 'محمد سعيد القاسمي', teachingSpecialization: 'الرقص التعبيري', specialization: 'رقص الباليه', school: 'المدرسة الأمريكية للإبداع', email: 'mohammed.q@production.ae', phone: '05 55 555 5555', isVerified: false, isActive: true, hasCertificate: true, projectNames: [] },
  { id: 12, name: 'شما عبدالرحمن', teachingSpecialization: 'التصوير الفوتوغرافي', specialization: 'التصوير والرسم والنحت', school: 'مدرسة دبي الوطنية', email: 'shama.a@production.ae', phone: '05 55 555 5555', isVerified: true, isActive: true, hasCertificate: true, projectNames: [] },
  { id: 13, name: 'يوسف عمر الفلاسي', teachingSpecialization: 'النحت والتشكيل', specialization: 'التصوير والرسم والنحت', school: 'أكاديمية الفنون الدولية', email: 'yousef.f@production.ae', phone: '05 55 555 5555', isVerified: true, isActive: true, hasCertificate: false, projectNames: [] },
  { id: 14, name: 'لطيفة حمد الزعابي', teachingSpecialization: 'الموسيقى والإيقاع', specialization: 'العزف والغناء', school: 'أكاديمية التربية الفنية', email: 'latifa.z@production.ae', phone: '05 55 555 5555', isVerified: true, isActive: true, hasCertificate: true, projectNames: [] },
  { id: 15, name: 'سلطان خليفة النقبي', teachingSpecialization: 'الفنون البصرية', specialization: 'التصوير والرسم والنحت', school: 'مدرسة الفجيرة النموذجية', email: 'sultan.n@production.ae', phone: '05 55 555 5555', isVerified: true, isActive: true, hasCertificate: true, projectNames: [] },
];

// ============================================================
// Section 6: Students
// ============================================================
const STUDENT_NAMES = [
  'سارة أحمد المنصوري', 'عبدالله محمد الشرقي', 'مريم خالد النعيمي',
  'حمدان سعيد الكتبي', 'شيخة عمر الظاهري', 'راشد يوسف الحمادي',
  'نورة سالم المهيري', 'سلطان أحمد القاسمي', 'فاطمة علي الفلاسي',
  'خالد حسن الزعابي', 'عائشة محمد الشامسي', 'عمر سعيد المزروعي',
  'حصة خالد العلي', 'أحمد عبدالله النقبي', 'مريم راشد الحسن',
  'سعيد محمد الشرقي', 'لطيفة أحمد المنصوري', 'يوسف عمر النعيمي',
  'شما سالم الكتبي', 'حمد خالد الظاهري', 'نورا محمد الحمادي',
  'عبدالرحمن سعيد المهيري', 'فاطمة يوسف القاسمي', 'خليفة أحمد الفلاسي',
  'عائشة عمر الزعابي', 'محمد حسن الشامسي', 'سارة خالد المزروعي',
  'راشد سعيد العلي', 'مريم أحمد النقبي', 'سلطان محمد الحسن',
  'حصة عمر الشرقي', 'عبدالله يوسف المنصوري', 'نورة خالد النعيمي',
  'أحمد سالم الكتبي', 'شيخة محمد الظاهري', 'حمدان أحمد الحمادي',
  'فاطمة سعيد المهيري', 'عمر خالد القاسمي', 'لطيفة محمد الفلاسي',
  'يوسف أحمد الزعابي', 'مريم حسن الشامسي', 'سعيد عمر المزروعي',
  'شما خالد العلي', 'خالد يوسف النقبي', 'عائشة أحمد الحسن',
  'حمد محمد الشرقي', 'نورا سالم المنصوري', 'عبدالرحمن خالد النعيمي',
  'سارة محمد الكتبي', 'راشد أحمد الظاهري', 'فاطمة عمر الحمادي',
  'سلطان سعيد المهيري',
];

const STATUSES: Array<'active' | 'proposed' | 'applied' | 'withdrawn'> = [
  'active', 'proposed', 'applied', 'withdrawn',
];

function generateStudents(): Student[] {
  return STUDENT_NAMES.map((name, i) => ({
    id: i + 1,
    name,
    specialization: SPECIALIZATIONS_LIST[i % SPECIALIZATIONS_LIST.length],
    school: SCHOOLS[i % SCHOOLS.length],
    email: `student${i + 1}@production.ae`,
    phone: '05 55 555 5555',
    status: STATUSES[i % STATUSES.length],
    performance: Math.floor(Math.random() * 40) + 60,
    isVerified: i % 3 !== 0,
    isActive: i % 5 !== 0,
    hasCertificate: i % 2 === 0,
  }));
}

const MOCK_STUDENTS_ALL: Student[] = generateStudents();

// ============================================================
// Paginated / Filtered Data Helpers
// ============================================================

export function getMockTeachers(
  page: number = 1,
  pageSize: number = 10,
  filters?: TalentsFilters,
  sortOrder?: 'asc' | 'desc',
): PaginatedData<Teacher> {
  let filtered = [...MOCK_TEACHERS_ALL];

  if (filters?.school) {
    filtered = filtered.filter(t => t.school === filters.school);
  }
  if (filters?.specialization) {
    filtered = filtered.filter(t => t.specialization === filters.specialization);
  }

  if (sortOrder) {
    filtered.sort((a, b) => {
      const cmp = a.name.localeCompare(b.name, 'ar');
      return sortOrder === 'asc' ? cmp : -cmp;
    });
  }

  const count = filtered.length;
  const start = (page - 1) * pageSize;
  const results = filtered.slice(start, start + pageSize);

  return { results, count, page, pageSize };
}

export function getMockStudents(
  page: number = 1,
  pageSize: number = 10,
  filters?: TalentsFilters,
  sortOrder?: 'asc' | 'desc',
): PaginatedData<Student> {
  let filtered = [...MOCK_STUDENTS_ALL];

  if (filters?.school) {
    filtered = filtered.filter(s => s.school === filters.school);
  }
  if (filters?.specialization) {
    filtered = filtered.filter(s => s.specialization === filters.specialization);
  }
  if (filters?.status) {
    filtered = filtered.filter(s => s.status === filters.status);
  }

  if (sortOrder) {
    filtered.sort((a, b) => {
      const cmp = a.name.localeCompare(b.name, 'ar');
      return sortOrder === 'asc' ? cmp : -cmp;
    });
  }

  const count = filtered.length;
  const start = (page - 1) * pageSize;
  const results = filtered.slice(start, start + pageSize);

  return { results, count, page, pageSize };
}

// Export unique values for filter dropdowns
export const UNIQUE_SCHOOLS = SCHOOLS;
export const UNIQUE_SPECIALIZATIONS = SPECIALIZATIONS_LIST;

// ============================================================
// Section 7: Activity Calendar Events
// ============================================================

/**
 * Helper: returns the Monday of the current week (ISO week start).
 * All mock events are anchored relative to this so the calendar
 * always shows data for "this week".
 */
function getCurrentWeekMonday(): Date {
  const now = new Date();
  const day = now.getDay(); // 0=Sun, 1=Mon, …
  const diff = day === 0 ? -6 : 1 - day;
  const monday = new Date(now);
  monday.setDate(now.getDate() + diff);
  monday.setHours(0, 0, 0, 0);
  return monday;
}

function offsetDate(base: Date, days: number): string {
  const d = new Date(base);
  d.setDate(base.getDate() + days);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function generateCalendarEvents(): CalendarEvent[] {
  const mon = getCurrentWeekMonday();
  let id = 1;
  const events: CalendarEvent[] = [];

  // Teal — painting/coloring events (أساسيات الرسم والتلوين, تقنيات متقدمة, مبادئ التلوين)
  events.push({ id: id++, title: 'أساسيات الرسم والتلوين', startTime: '09:00', endTime: '10:00', date: offsetDate(mon, 1), category: 'painting' }); // Tue
  events.push({ id: id++, title: 'تقنيات متقدمة في التلوين الزيتي - جزء 1', startTime: '09:00', endTime: '10:00', date: offsetDate(mon, 5), category: 'painting' }); // Sat
  events.push({ id: id++, title: 'مبادئ التلوين الزيتي', startTime: '10:00', endTime: '11:00', date: offsetDate(mon, 3), category: 'painting' }); // Thu

  // Blue — sculpting events (تقنيات النحت, أساسيات النحت)
  events.push({ id: id++, title: 'أساسيات النحت للمبتدئين', startTime: '11:00', endTime: '11:30', date: offsetDate(mon, 1), category: 'sculpting' }); // Tue
  events.push({ id: id++, title: 'تقنيات النحت - جزء 1', startTime: '11:00', endTime: '11:30', date: offsetDate(mon, 2), category: 'sculpting' }); // Wed
  events.push({ id: id++, title: 'تقنيات النحت - جزء 2', startTime: '11:00', endTime: '11:30', date: offsetDate(mon, 4), category: 'sculpting' }); // Fri
  events.push({ id: id++, title: 'تقنيات النحت - جزء 3', startTime: '11:00', endTime: '11:30', date: offsetDate(mon, 5), category: 'sculpting' }); // Sat

  // Purple — drawing events (تقنيات الرسم, أساسيات الرسم للمبتدئين)
  events.push({ id: id++, title: 'أساسيات الرسم للمبتدئين', startTime: '12:00', endTime: '13:00', date: offsetDate(mon, 1), category: 'drawing' }); // Tue
  events.push({ id: id++, title: 'تقنيات الرسم - جزء 1', startTime: '12:00', endTime: '13:00', date: offsetDate(mon, 3), category: 'drawing' }); // Thu
  events.push({ id: id++, title: 'تقنيات الرسم - جزء 2', startTime: '12:00', endTime: '13:00', date: offsetDate(mon, 5), category: 'drawing' }); // Sat

  // Orange — programming (برمجة الحاسوب, Tue/Thu/Sat 14:00-15:30)
  for (const dayOffset of [1, 3, 5]) {
    events.push({ id: id++, title: 'برمجة الحاسوب', startTime: '14:00', endTime: '15:30', date: offsetDate(mon, dayOffset), category: 'programming', participantCount: 3 });
  }

  // Cyan — sports (النشاط البدني, Tue/Thu/Sat 18:30-19:30)
  for (const dayOffset of [1, 3, 5]) {
    events.push({ id: id++, title: 'النشاط البدني', startTime: '18:30', endTime: '19:30', date: offsetDate(mon, dayOffset), category: 'sports', participantCount: 4 });
  }

  // Pink — arts & music (الفنون والموسيقى, Wed/Thu 16:00-18:00)
  for (const dayOffset of [2, 3]) {
    events.push({ id: id++, title: 'الفنون والموسيقى', startTime: '16:00', endTime: '18:00', date: offsetDate(mon, dayOffset), category: 'music', participantCount: 3 });
  }

  return events;
}

export const MOCK_CALENDAR_EVENTS: CalendarEvent[] = generateCalendarEvents();

// ============================================================
// Section 8: Specialization Detail
// ============================================================
import {
  SpecializationDetailData,
  DetailStudent,
} from './types';

const AGE_GROUPS = ['المرحلة التأسيسية', 'المرحلة المتوسطة', 'المرحلة الثانوية'];
const LEVELS = ['الناشئة', 'الواعدة', 'المتميزة', 'القابلة للتمثيل الخارجي'];
const PROGRAMS_LIST = [
  'مشروع تنمية مواهب الرسم',
  'مشروع تنمية مواهب التصوير',
  'مشروع تنمية مواهب النحت',
];

function generateDetailStudents(): DetailStudent[] {
  return MOCK_STUDENTS_ALL
    .filter(s => s.specialization === 'التصوير والرسم والنحت')
    .map((s, i) => ({
      ...s,
      programs: PROGRAMS_LIST[i % PROGRAMS_LIST.length],
      ageGroup: AGE_GROUPS[i % AGE_GROUPS.length],
      level: LEVELS[i % LEVELS.length],
    }));
}

const MOCK_DETAIL_STUDENTS: DetailStudent[] = generateDetailStudents();

export function getMockDetailStudents(
  page: number = 1,
  pageSize: number = 10,
  filters?: TalentsFilters,
  sortOrder?: 'asc' | 'desc',
): PaginatedData<DetailStudent> {
  let filtered = [...MOCK_DETAIL_STUDENTS];

  if (filters?.school) {
    filtered = filtered.filter(s => s.school === filters.school);
  }
  if (filters?.status) {
    filtered = filtered.filter(s => s.status === filters.status);
  }

  if (sortOrder) {
    filtered.sort((a, b) => {
      const cmp = a.name.localeCompare(b.name, 'ar');
      return sortOrder === 'asc' ? cmp : -cmp;
    });
  }

  const count = filtered.length;
  const start = (page - 1) * pageSize;
  const results = filtered.slice(start, start + pageSize);

  return { results, count, page, pageSize };
}

export function getMockDetailTeachers(
  page: number = 1,
  pageSize: number = 3,
  sortOrder?: 'asc' | 'desc',
): PaginatedData<Teacher> {
  let filtered = MOCK_TEACHERS_ALL.filter(t => t.specialization === 'التصوير والرسم والنحت');

  if (sortOrder) {
    filtered.sort((a, b) => {
      const cmp = a.name.localeCompare(b.name, 'ar');
      return sortOrder === 'asc' ? cmp : -cmp;
    });
  }

  const count = filtered.length;
  const start = (page - 1) * pageSize;
  const results = filtered.slice(start, start + pageSize);

  return { results, count, page, pageSize };
}

export const MOCK_SPECIALIZATION_DETAIL: SpecializationDetailData = {
  id: 1,
  title: 'التصوير والرسم والنحت',
  description: 'اختصاص يستهدف المواهب في مجالات التصوير والرسم والنحت',
  weight: 30,
  studentsCount: 14,
  teachersCount: 3,
  activitiesCount: 0,
  kpisCount: 2,
  programsCount: 3,
  overallProgress: 76,
  statusDistribution: {
    excellent: 80,
    good: 20,
    needsImprovement: 0,
  },
  statistics: [
    {
      title: 'المشاركين وفق الفئات العمرية',
      total: 14,
      showTotal: true,
      segments: [
        { label: 'المرحلة الثانوية', value: 5, color: '#3a5aa3' },
        { label: 'المرحلة المتوسطة', value: 5, color: '#414042' },
        { label: 'المرحلة التأسيسية', value: 4, color: '#a6813f' },
      ],
    },
    {
      title: 'المشاركين وفق فئات المستويات',
      total: 14,
      showTotal: false,
      segments: [
        { label: 'الناشئة', value: 5, color: '#a6813f' },
        { label: 'الواعدة', value: 4, color: '#414042' },
        { label: 'المتميزة', value: 3, color: '#3a5aa3' },
        { label: 'القابلة للتمثيل الخارجي', value: 2, color: '#a9211f' },
      ],
    },
  ],
  kpis: [
    {
      id: 1,
      name: 'عدد المشاريع والبرامج التدريبية المنفذة',
      targetValue: 3,
      achievedValue: 3,
      unit: 'count',
      isAchieved: true,
    },
    {
      id: 2,
      name: 'نسبة التزام الطلبة في الانشطة',
      targetValue: 100,
      achievedValue: 68,
      unit: 'percentage',
      isAchieved: false,
    },
  ],
  programs: [
    { id: 1, name: 'مشروع تنمية مواهب الرسم', progress: 77 },
    { id: 2, name: 'مشروع تنمية مواهب التصوير', progress: 75 },
    { id: 3, name: 'مشروع تنمية مواهب النحت', progress: 76 },
  ],
  outputs: [
    {
      id: 1,
      title: 'معرض طلاب وشة العمل - 6/8/2026',
      image: require('../../../assets/images/talents-output-3.png'),
    },
    {
      id: 2,
      title: 'معرض طلاب وشة العمل 3 - 26/10/2026',
      image: require('../../../assets/images/talents-output-2.png'),
    },
    {
      id: 3,
      title: 'مشاركة الطلاب في مبادرة شارع الفنانين',
      image: require('../../../assets/images/talents-output-1.png'),
    },
  ],
  developmentPlan: {
    title: 'خطة متابعة وتنمية الطلبة لاختصاص التصوير والرسم والنحت',
    content: `خطة متابعة وتنمية الطلبة لاختصاص التصوير والرسم والنحت

• 1. المرحلة الأولى:
  • الاسم الأول
  • الاسم الأخير
  • البريد الالكتروني
  • الهاتف
  • تاريخ الميلاد
  • الجنس
• 2. المرحلة الثانية:
  • اسم المستخدم
  • كلمة المرور
  • الجهة
  • الوحدة التنظيمية
  • نوع المستخدم
  • المسمى الوظيفي
  • تاريخ التسجيل
• 3. المرحلة الثالثة:
  • الاسم الأول
  • الاسم الأخير
  • البريد الالكتروني
  • الهاتف
  • تاريخ الميلاد
  • الجنس
• 4. الملف التعريفي:
  • اسم المستخدم`,
  },
  planAttachments: [],
};

// ============================================================
// Section 9: Project Detail
// ============================================================

export const MOCK_PROJECT_DETAIL: ProjectDetailData = {
  id: 1,
  title: 'مشروع تنمية مواهب الرسم',
  dateRange: '1 مايو 2026 - 12 سبتمبر 2026',
  description: 'يهدف المشروع إلى تحديد ورعاية المواهب الفنية الشابة في فئة الرسم وتوفير البرامج والأنشطة المناسبة لتنميتها',
  weight: 30,
  studentsCount: 8,
  teachersCount: 3,
  kpisCount: 2,
  activitiesCount: 2,
  sessionsCount: 0,
  overallProgress: 77,
  statusDistribution: {
    excellent: 100,
    good: 0,
    needsImprovement: 0,
  },
  kpis: [
    {
      id: 1,
      name: 'عدد الأنشطة التدريبية المنفذة شهرياً',
      targetValue: 2,
      achievedValue: 2,
      unit: 'count',
      isAchieved: true,
    },
    {
      id: 2,
      name: 'نسبة التزام الطلبة في الانشطة',
      targetValue: 100,
      achievedValue: 68,
      unit: 'percentage',
      isAchieved: false,
    },
  ],
  activities: [
    { id: 1, name: 'ورشة الرسم بالألوان الزيتية', progress: 77 },
    { id: 2, name: 'ورشة تقنيات الرسم', progress: 75 },
  ],
  outputs: [
    {
      id: 1,
      title: 'معرض طلاب وشة العمل - 6/8/2026',
      image: require('../../../assets/images/talents-output-3.png'),
    },
    {
      id: 2,
      title: 'مشاركة الطلاب في مبادرة شارع الفنانين',
      image: require('../../../assets/images/talents-output-1.png'),
    },
    {
      id: 3,
      title: 'سجل حضور الطلاب في المعرض',
    },
  ],
  sustainabilityPlan: {
    title: 'خطة استدامة دعم الطلبة لاختصاص التصوير والرسم والنحت',
    content: `خطة استدامة دعم الطلبة لاختصاص التصوير والرسم والنحت

• 1. المرحلة الأولى:
  • الاسم الأول
  • الاسم الأخير
  • البريد الالكتروني
  • الهاتف
  • تاريخ الميلاد
  • الجنس
• 2. المرحلة الثانية:
  • اسم المستخدم
  • كلمة المرور
  • الجهة
  • الوحدة التنظيمية
  • نوع المستخدم
  • المسمى الوظيفي
  • تاريخ التسجيل
• 3. المرحلة الثالثة:
  • الاسم الأول
  • الاسم الأخير
  • البريد الالكتروني
  • الهاتف
  • تاريخ الميلاد
  • الجنس
• 4. الملف التعريفي:
  • اسم المستخدم`,
  },
};

// ============================================================
// Section 10: Output Gallery Detail
// ============================================================

const galleryImg1 = require('../../../assets/images/talents-output-1.png');
const galleryImg2 = require('../../../assets/images/talents-output-2.png');
const galleryImg3 = require('../../../assets/images/talents-output-3.png');

export const MOCK_OUTPUT_GALLERY: OutputGalleryData = {
  id: 1,
  title: 'معرض طلاب وشة العمل - 6/8/2026',
  heroImage: galleryImg3,
  photos: [
    { id: 1, image: galleryImg2, caption: 'مشاركة: أمل برهان', type: 'image', studentName: 'أمل برهان' },
    { id: 2, image: galleryImg2, caption: 'مشاركة: احمد الراشد', type: 'image', studentName: 'احمد الراشد' },
    { id: 3, image: galleryImg3, caption: 'مشاركة: مصطفى عبدالله', type: 'image', studentName: 'مصطفى عبدالله' },
    { id: 4, image: galleryImg3, caption: 'مشاركة: مصطفى عبدالله', type: 'image', studentName: 'مصطفى عبدالله' },
    { id: 5, image: galleryImg2, caption: 'مشاركة: احمد الراشد', type: 'image', studentName: 'احمد الراشد' },
    { id: 6, image: galleryImg2, caption: 'مشاركة: مصطفى عبدالله', type: 'image', studentName: 'مصطفى عبدالله' },
    { id: 7, image: galleryImg2, caption: 'مشاركة: مصطفى عبدالله', type: 'image', studentName: 'مصطفى عبدالله' },
    { id: 8, image: galleryImg3, caption: 'مشاركة: أمل برهان', type: 'image', studentName: 'أمل برهان' },
  ],
  videos: [
    { id: 101, image: galleryImg1, caption: 'مشاركة الطلاب في مبادرة شارع الفنانين', type: 'video' },
    { id: 102, image: galleryImg1, caption: 'مشاركة الطلاب في مبادرة شارع الفنانين', type: 'video' },
    { id: 103, image: galleryImg1, caption: 'مشاركة الطلاب في مبادرة شارع الفنانين', type: 'video' },
  ],
  files: [
    { id: 201, caption: 'سجلات الحضور.excel', type: 'file' as const, image: null as any },
  ],
};

// ============================================================
// Section 11: Student Detail
// ============================================================

export const MOCK_STUDENT_DETAIL: StudentDetailData = {
  id: 1,
  name: 'مصطفى عبدالله',
  school: 'ثانوية الفجيرة الخاصة',
  specialization: 'التصوير والرسم والنحت',
  // Personal info
  eid: '',
  nationality: '',
  email: 'mustaf.m.a@mail.com',
  phone: '055 555 55555',
  birthDate: '16 يونيو، 2010',
  gender: 'ذكر',
  registrationDate: '9 أغسطس، 2022',
  // Profile info
  ageGroup: 'المرحلة الثانوية',
  level: 'الفئة الواعدة',
  status: 'active',
  // Performance
  overallPerformance: 92,
  kpisCount: 2,
  kpis: [
    {
      id: 1,
      name: 'نسبة التزام الطالب بالبرامج التدريبية والورش الفنية المسجل بها',
      targetValue: 100,
      achievedValue: 94,
      unit: 'percentage',
      isAchieved: false,
    },
    {
      id: 2,
      name: 'نسبة تطور موهبة الطالب والاستجابة للبرامج التدريبية والورش الفنية',
      targetValue: 100,
      achievedValue: 90,
      unit: 'percentage',
      isAchieved: false,
    },
  ],
  // Enrolled items
  specializations: [
    {
      id: 1,
      title: 'التصوير والرسم والنحت',
      progress: 76,
      kpiCount: 3,
      activityCount: 3,
      participantCount: 14,
    },
  ],
  programs: [
    { id: 1, name: 'مشروع تنمية مواهب الرسم', progress: 77 },
  ],
  activities: [
    { id: 1, name: 'ورشة الرسم بالألوان الزيتية', progress: 76 },
  ],
  outputs: [
    {
      id: 1,
      title: 'معرض طلاب وشة العمل - 6/8/2026',
      image: require('../../../assets/images/talents-output-3.png'),
    },
    {
      id: 2,
      title: 'مشاركة الطلاب في مبادرة شارع الفنانين',
      image: require('../../../assets/images/talents-output-1.png'),
    },
  ],
};
